import { setHideFiltered } from './chatFilterSetters';
const updateFilteredToggle = (filters, filterValue) => {
  return setHideFiltered(filterValue, filters);
};
export default updateFilteredToggle;